import FindTextInput from './FindTextInput';

export default FindTextInput;
